var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"src":require("../../public/favicon.png")}}),_c('h3',[_vm._v("Post Receipt Webview")]),_c('p',[_vm._v("powered by Olsera")])])
}]

export { render, staticRenderFns }